
























import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import { ISorter } from "@/models/tables";
import { Sorters } from "@/data/table";

@Component
export default class DataSorter extends Vue {
  @Prop({ required: true })
  public sorters!: ISorter[];

  @Prop({ required: true })
  public activeSort!: ISorter;

  public sort: ISorter = {
    field: this.activeSort.field,
    direction: this.activeSort.direction
  };

  public get sortIcon(): string {
    return this.sort.direction === Sorters.ASCENDING
      ? "sort-amount-up"
      : "sort-amount-down";
  }

  public changeField() {
    this.$emit(
      "onSort",
      this.sort.field,
      this.sort.field ? this.sort.direction : Sorters.DESCENDING
    );
  }

  public changeDirection() {
    this.sort.direction =
      this.sort.direction === Sorters.ASCENDING
        ? Sorters.DESCENDING
        : Sorters.ASCENDING;
    this.$emit("onSort", this.sort.field, this.sort.direction);
  }

  public get isLocked() {
    return this.$_.get(this.activeSort, "field") === "";
  }

  @Watch("activeSort")
  public onActiveSortChange() {
    if (this.sort.direction !== this.activeSort.direction) {
      this.sort.direction = this.activeSort.direction;
    }
    if (this.sort.field !== this.activeSort.field) {
      this.sort.field = this.activeSort.field;
    }
  }
}
